import { ViewModel,View } from "binder"
import { IExecutablePart } from "../../executablePart/executablePart";
import { ExecutableViewModel } from "../executable-viewModel";
import { PartTypeSelectorViewModel } from "../partTypeSelector/partTypeSelector-viewModel";
import  { PreAfterAdderView } from "./preAfterAdder-view"

export class PreAfterAdderViewModel extends ViewModel{
    constructor(parentViewModel: ExecutableViewModel) {
        super(parentViewModel);
        this.typedParent = parentViewModel;
    }
    GetDefaultView(): View <ViewModel> {
        return new PreAfterAdderView();
    }
    public getTypeId(): string {
        return "VM-A7B5EE6C-BF8B-40A7-AE59-55B7E0BCC8B6"
    }

    private typedParent : ExecutableViewModel;
    public set shallShow(v: boolean) { this._shallShow = v; } public get shallShow(): boolean { return this._shallShow;} private _shallShow: boolean;
    public set part(v: IExecutablePart) { this._part = v; } public get part(): IExecutablePart { return this._part;} private _part: IExecutablePart;
    
    async addBefore(){
        let selector = new PartTypeSelectorViewModel(this);
        let result = await this.requestShowingPopup(selector,false);
        if(result){
            let element = result.factory(this.typedParent);
            this.typedParent.addBefore(element,this);
        }
    }
    async addAfter(){
        let selector = new PartTypeSelectorViewModel(this);
        let result = await this.requestShowingPopup(selector,false);
        if(result){
            let element = result.factory(this.typedParent);
            this.typedParent.addAfter(element,this);
        }
    }
    remove(){
        this.typedParent.removeExecutablePart(this);
    }
}
